<app-debug-bar></app-debug-bar>
<router-outlet></router-outlet>